type Platform = "ios" | "android" | "other";

let cachedPlatform: Platform | null = null;

export function detectPlatform(ua: string = navigator.userAgent): Platform {
  const lower = ua.toLowerCase();
  if (/ipad|iphone|ipod/.test(lower)) return "ios";
  if (/android/.test(lower)) return "android";
  return "other";
}

export function platform(): Platform {
  if (cachedPlatform) return cachedPlatform;
  cachedPlatform = detectPlatform();
  return cachedPlatform;
}

export function buildDirectionsUrl(lat: number, lon: number, p: Platform = platform()): string {
  if (p === "ios") {
    return `https://maps.apple.com/?daddr=${lat},${lon}&dirflg=w`;
  }
  if (p === "android") {
    return `geo:${lat},${lon}?q=${lat},${lon}(Toilet)`;
  }
  return `https://www.google.com/maps/dir/?api=1&destination=${lat},${lon}&travelmode=walking`;
}

export function openDirections(lat: number, lon: number): void {
  const url = buildDirectionsUrl(lat, lon);
  window.location.href = url;
}

export function _resetCacheForTests(): void {
  cachedPlatform = null;
}
